module.exports = __webpack_public_path__ + "img/17-detail.7bcb9355.jpg";